import { Component, OnInit, OnDestroy, HostListener, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AuthService } from '../../shared/auth.service';
import { environment } from '../../../environments/environment';
import { menuItems } from '../../models/menu.model';

@Component({
  selector: 'pcc-header',
  templateUrl: 'header.component.html',
  styleUrls: ['header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Output() showHelp = new EventEmitter<any>();
  appTitle: string;
  userIsAuthenticated = false;
  userAvatarUrl = '';
  mobileDevice: boolean = window.innerWidth <= environment.mobileMaxWidth;
  menuItems: MenuItem[];
  headerMenuItems: MenuItem[] = [
    {
      label: 'Settings',
      routerLink: '/settings'
    },
    {
      label: 'Messages',
      routerLink: '/messages'
    },
    {
      label: 'Cart',
      routerLink: '/cart'
    },
    {
      separator: true
    }
  ];
  userMenuItems: MenuItem[] = [
    {
      label: 'Logout',
      command: () => this.logout()
    },

  ];
  private subs: Subscription[] = [];
  constructor(private router: Router, private authService: AuthService) { }

  ngOnInit() {
    if (!this.authService.isAuthenticated) {
      this.authService.autoLogin();
    }
    this.menuItems = [...this.headerMenuItems, ...menuItems];
    this.userIsAuthenticated = this.authService.isAuthenticated;
    this.userAvatarUrl = this.authService.userAvatarUrl;
    this.subs.push(this.authService.authStatusListener.subscribe(authStatus => {
      this.userIsAuthenticated = authStatus === 'success' ? true : false;
      this.userAvatarUrl = this.authService.userAvatarUrl;
    }));
    this.appTitle = this.mobileDevice ? environment.shortAppTitle : environment.appTitle;
  }

  logout() {
    this.authService.logout();
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  helpClicked() {
    this.showHelp.emit(); // this will trigger the help panel from app-comnponent
  }

  @HostListener('window:resize', ['$event'])
  windowResize() {
    this.mobileDevice = window.innerWidth <= environment.mobileMaxWidth;
    this.appTitle = this.mobileDevice ? environment.shortAppTitle : environment.appTitle;
  }
}

